import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
const json = require("json!./../../../resources/properties.json");

@Injectable()
export class RegisterService {

    private serverURL: string;

    constructor(private http: Http) {
        this.serverURL = json.api_url;
    }

    getUserStatus(): Promise<any> {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return "guest";
                } else {
                    return JSON.parse(res.text());
                }
            }).catch(this.handleError);
        } else {
            return Promise.resolve({ role: "guest" });
        }

    }

    existsEmail(email: string) {
        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }, this.handleError);
    }

    register(formData: Object) {
        /*
         * If we had a login api, we would have done something like this
         */
        return this.http.post(this.serverURL + '/loginData/register', this.serializeObj(formData), {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        })
            .map((res: any) => {
                let data = res.json();                
                localStorage.setItem('token', data.token);
                localStorage.setItem('idUser', data.user_id.toString());
                localStorage.setItem('userName', data.user_name);
                return data;
            });
    }

    private handleError(error: any): Promise<any> {        
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    private serializeObj(obj: any): String {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/register/register.service.ts
 **/